export const isNotEmpty = (value: string) => {
  return value !== "";
};

// eslint-disable-next-line
export const isNotUndefinied = (value: any) => {
  return value !== undefined;
};

// eslint-disable-next-line
export const doesExist = (value: any): boolean => {
  return value !== null && value !== undefined;
};

export const isNullOrWhitespace = (value: string): boolean => {
  return value == null || value == undefined || value.trim() === "";
};

export const isValidGuid = (value: string): boolean => {
  const regex = new RegExp(
    /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/,
  );
  let isValid = false;
  if (value != null && regex.test(value) === true) {
    isValid = true;
  }

  return isValid;
};

// eslint-disable-next-line
export const hasValue = (value: any): boolean => {
  return doesExist(value) && isNotEmpty(value);
};

export const doesNotStartOrEndWithWhitespace = (content: string): boolean => {
  return /^[^\s]+(\s+[^\s]+)*$/.test(content);
};

export const isNumeric = (value: string) => {
  const result = parseFloat(value);
  return !Number.isNaN(result);
};
